import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, styled, Typography } from '@mui/material';

export const ErrorContainerStyled = styled(Box)(({ theme }) => ({
  width: '100%',
  backgroundColor: theme.palette.colors.infoBackground,
  border: `1px solid ${theme.palette.colors.down}`,
  borderRadius: '8px',
  padding: '8px 8px 12px 24px',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  marginBottom: '4px',
  [theme.breakpoints.down('lg')]: {
    marginBottom: '10px',
  },
}));

export const ErrorIconStyled = styled(FontAwesomeIcon)(({ theme }) => ({
  fontSize: '28px',
  fontWeight: 'bold',
  color: theme.palette.colors.down,
}));

export const TextContainerStyled = styled(Box)(() => ({
  paddingLeft: '16px',
  display: 'flex',
  flexDirection: 'column',
  overflow: 'auto',
  width: '100%',
}));

export const HeaderContainerStyled = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  paddingRight: '2px',
  marginBottom: '8px',
}));

export const TitleStyled = styled(Typography)(({ theme }) => ({
  fontSize: '14px',
  fontWeight: 'bold',
  color: theme.palette.colors.onSecondaryAndDetailBackground,
}));

export const CloseContainerIconStyled = styled(FontAwesomeIcon)(
  ({ theme }) => ({
    fontSize: '14px',
    color: theme.palette.colors.onSecondaryAndDetailBackground,
  }),
);

export const DescriptionContainerStyled = styled(Box)(({ theme }) => ({
  maxHeight: '72px',
  paddingRight: '5px',
  overflow: 'auto',

  '@-moz-document url-prefix()': {
    scrollbarColor: `${theme.palette.colors.scrollOnPrimaryBackground} transparent`,
    scrollbarWidth: 'thin',
  },
  '&::-webkit-scrollbar': {
    width: '6px',
  },
  '&::-webkit-scrollbar-track': {
    boxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
    webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: theme.palette.colors.scrollOnPrimaryBackground,
    borderRadius: '5px',
  },
}));

export const DescriptionStyled = styled(Typography)(({ theme }) => ({
  fontSize: '12px',
  lineHeight: 1.5,
  color: theme.palette.colors.onSecondaryAndDetailBackground,
}));
